import { ref } from 'vue';

export const INVALID_JWT_ERROR = 'invalid-jwt-token-error';

const showSessionExpiredModal = ref(false);

export function useSessionExpiry() {
  const flagSessionExpired = () => {
    showSessionExpiredModal.value = true;
  };

  const clearSessionExpired = () => {
    showSessionExpiredModal.value = false;
  };

  return {
    showSessionExpiredModal,
    flagSessionExpired,
    clearSessionExpired,
  };
}
